import { motion } from "framer-motion";

/**
 * FadeIn — very slow, restrained fade-in only (no slide, no bounce).
 * Triggered once when element enters viewport.
 */
export const FadeIn = ({
  children,
  delay = 0,
  duration = 1.8,
  className = "",
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.22, 0.61, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default FadeIn;
